import { jsx as _jsx } from "react/jsx-runtime";
import InfoCardGroupBase from './InfoCardGroup/InfoCardGroupBase';
/**
 * @export
 * A component that displays a group of profile images stacked horizontally with overlap.
 * Shows a "+N" badge for remaining items when maxVisible limit is reached.
 * Clicking opens a dropdown with full ItemCards, which can be clicked for detailed info.
 *
 * This is a **display-only** component. For editable/input mode, use InfoCardGroupInput.
 *
 * @example Basic usage:
 * ```
 * <InfoCardGroup
 *   items={[
 *     { avatar: 'https://example.com/1.jpg', name: 'John Doe', email: 'john@example.com' },
 *     { avatar: 'https://example.com/2.jpg', name: 'Jane Smith', email: 'jane@example.com' },
 *   ]}
 *   fields={{ image: 'avatar', name: 'name', title: 'name', subtitle: 'email' }}
 *   maxVisible={3}
 * />
 * ```
 *
 * @example With details:
 * ```
 * <InfoCardGroup
 *   items={users}
 *   fields={{ image: 'avatar', name: 'name', title: 'name', subtitle: 'email' }}
 *   details={(item) => ({
 *     fields: [
 *       { label: 'Department', value: item.department },
 *       { label: 'Phone', value: item.phone }
 *     ]
 *   })}
 *   maxVisible={4}
 *   size="medium"
 *   shape="circle"
 * />
 * ```
 */
const InfoCardGroup = (props) => {
    return _jsx(InfoCardGroupBase, Object.assign({}, props));
};
export default InfoCardGroup;
